import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("option", {
  value: "-1",
  disabled: "disabled",
  hidden: "hidden"
}, "Loading...", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Do not receive any emails", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Receive only major update emails", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Receive major and minor update emails", -1)
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("select", _mergeProps({
      class: "form-control",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.level) = $event))
    }, _ctx.$attrs, {
      disabled: _ctx.isFetching || _ctx.saving
    }), _hoisted_6, 16, _hoisted_1), [
      [_vModelSelect, _ctx.level]
    ]),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "There was an error saving your subscription"))
      : (_ctx.saved && !_ctx.saving)
        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Changes successfully saved"))
        : _createCommentVNode("", true)
  ], 64))
}